var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex start-v",staticStyle:{"width":"100%"}},[_c('img',{attrs:{"src":require("@img/ui_fin.png"),"alt":""}}),_c('p',[_vm._v("恭喜你已完成全部答题")]),_c('button',{staticClass:"btn-full",on:{"click":function($event){return _vm.$emit('review')}}},[_vm._v("查看记录")])])
}
var staticRenderFns = []

export { render, staticRenderFns }